import styled from '@emotion/styled';
import React from 'react';

import { ReactComponent as BgImage } from '@skippay/core/assets/illustrations/bg-circles.svg';

interface BgCircleProps {
	width?: string;
	top?: string;
	left?: string;
	right?: string;
	bottom?: string;
	move?: string;
	position?: 'absolute' | 'fixed' | 'relative' | 'static';
	hideSmallBubbles?: boolean;
	className?: string;
}

const SBg = styled.div<BgCircleProps>`
	position: ${({ position }) => position || 'absolute'};
	width: ${({ width }) => width || 'auto'};
	height: auto;
	left: ${({ left }) => left || 'auto'};
	right: ${({ right }) => right || 'auto'};
	top: ${({ top }) => top || 'auto'};
	bottom: ${({ bottom }) => bottom || 'auto'};
	z-index: 0;
	overflow: hidden;

	svg {
		width: 100%;
		height: auto;
		transform: translate(${({ move }) => move || '0 0'});
	}

	.bg-circles_svg__small {
		display: ${({ hideSmallBubbles }) => (hideSmallBubbles ? 'none' : 'block')};
	}
`;

function BgCircles(props: BgCircleProps): JSX.Element {
	return (
		<SBg {...props}>
			<BgImage />
		</SBg>
	);
}

export default BgCircles;
